// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: #e9e9e9;
}

h1 {
  margin: 0;
  padding: 0;
}

div {
  padding: 0;
}

hr {
  border-top: 1px solid #666;
}

a {
  color: #ABABAB;
}

#loginBox {
  padding-top: 50px;
}

.borderWarning {
  border: 2px solid red;
}

#container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-image: url('background.png');
}

#logoContainer {
  margin-top: 25px;
  margin-bottom: 50px;
}

.pNull {
  padding: 0;
  margin: 0 0 7px;
}

#loginIconContainer {
  margin-right: 10px;
  margin-top: 1px;
}

.rememberMe {
  padding-top: 6px;
}

#tagTop {
  font-size: 11.5pt;
}

#tagLineContainer {
  margin-top: 70px;
  margin-right: 20px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
@media only screen and (min-width: 950px) and (max-width: 1024px), only screen and (min-width: 530px) and (max-width: 949px) {
  #tagLineContainer {
    margin-top: 0;
    margin-right: 0;
    width: 315px;
    position: relative;
    left: 55px;
    top: 20px;
  }
}

#tagMid {
  font-size: 24pt;
}

.tagEnd {
  font-size: 20pt;
}

.tagEndBottom {
  padding-left: 45px;
}

/**
app-form-table ::ng-deep #table_loginForm {
    border: 3px solid blue;
}
app-form-table ::ng-deep #table_loginForm tr td {
    border: 2px solid yellow;
}
app-form-table ::ng-deep #table_loginForm tr:first-child td,
app-form-table ::ng-deep #table_loginForm tr:nth-child(2) td {
    display: block;
    border: 1px solid red;
}
*/
app-form-table ::ng-deep #table_loginForm {
  max-width: 325px;
}

app-form-table ::ng-deep #loginForm-0-1-0-tbox_container input,
app-form-table ::ng-deep #loginForm-0-3-0-middle_field div.formInnerDiv,
app-form-table ::ng-deep #loginForm-0-3-0-tbox_container input {
  width: 100%;
  color: black;
}

app-form-table ::ng-deep #loginForm-0-4-0-blank-html span a {
  color: #CCC;
}

app-form-table ::ng-deep #loginForm-0-4-0-blank-html span a:hover {
  color: #EDF2F5;
}

app-form-table ::ng-deep #loginForm-0-5-0-right_text {
  padding-left: 10px;
}

app-form-table ::ng-deep #loginForm-0-5-0-middle_field {
  padding-top: 15px;
}

app-form-table ::ng-deep #loginForm-0-5-1-middle_field {
  padding-top: 10px;
}

app-form-table ::ng-deep #loginForm-0-5-1-submit_button button:hover {
  background-color: #BBB;
}

.inputForm {
  color: black;
}

.text-danger {
  color: indianred;
}

div.mpo {
  margin-right: 20px !important;
  font-size: 20pt;
}

div.mpo p {
  width: 232px;
  margin: auto;
  text-align: left;
  height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/app/components/resetpass/resetpass.component.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,UAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,0BAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uCAAA;AADJ;;AAIA;EACI,gBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,UAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,eAAA;AADJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;AAFJ;AAII;EATJ;IAUQ,aAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;EADN;AACF;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;;;;;;;;;;;;CAAA;AAcA;EACI,gBAAA;AAFJ;;AAKA;;;EAGI,WAAA;EACA,YAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,6BAAA;EACA,eAAA;AAFJ;;AAKA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAFJ","sourcesContent":["@use \"./../../../../responsive\" as responsive;\n\n* {\n    color: #e9e9e9;\n}\n\nh1 {\n    margin: 0;\n    padding: 0;\n}\n\ndiv {\n    padding: 0;\n}\n\nhr {\n    border-top: 1px solid #666;\n}\n\na {\n    color: #ABABAB\n}\n\n#loginBox {\n    padding-top: 50px;\n}\n\n.borderWarning {\n    border: 2px solid red;\n}\n\n#container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-image: url('../../../../assets/login/background.png');\n}\n\n#logoContainer {\n    margin-top: 25px;\n    margin-bottom: 50px;\n}\n\n.pNull {\n    padding: 0;\n    margin: 0 0 7px;\n}\n\n#loginIconContainer {\n    margin-right: 10px;\n    margin-top: 1px;\n\n}\n\n.rememberMe {\n    padding-top: 6px;\n}\n\n#tagTop {\n    font-size: 11.5pt;\n}\n\n#tagLineContainer {\n    margin-top: 70px;\n    margin-right: 20px;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    @media #{ responsive.$tablet-landscape, responsive.$tablet } {\n        margin-top: 0;\n        margin-right: 0;\n        width: 315px;\n        position: relative;\n        left: 55px;\n        top: 20px;\n    }\n}\n\n#tagMid {\n    font-size: 24pt;\n}\n\n.tagEnd {\n    font-size: 20pt;\n}\n\n.tagEndBottom {\n    padding-left: 45px;\n}\n\n/**\napp-form-table ::ng-deep #table_loginForm {\n    border: 3px solid blue;\n}\napp-form-table ::ng-deep #table_loginForm tr td {\n    border: 2px solid yellow;\n}\napp-form-table ::ng-deep #table_loginForm tr:first-child td,\napp-form-table ::ng-deep #table_loginForm tr:nth-child(2) td {\n    display: block;\n    border: 1px solid red;\n}\n*/\n\napp-form-table ::ng-deep #table_loginForm {\n    max-width: 325px;\n}\n\napp-form-table ::ng-deep #loginForm-0-1-0-tbox_container input,\napp-form-table ::ng-deep #loginForm-0-3-0-middle_field div.formInnerDiv,\napp-form-table ::ng-deep #loginForm-0-3-0-tbox_container input {\n    width: 100%;\n    color: black;\n}\n\napp-form-table ::ng-deep #loginForm-0-4-0-blank-html span a {\n    color: #CCC;\n}\n\napp-form-table ::ng-deep #loginForm-0-4-0-blank-html span a:hover {\n    color: #EDF2F5;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-0-right_text {\n    padding-left: 10px;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-0-middle_field {\n    padding-top: 15px;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-1-middle_field {\n    padding-top: 10px;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-1-submit_button button:hover {\n    background-color: #BBB;\n}\n\n.inputForm {\n    color: black;\n}\n\n.text-danger {\n    color: indianred;\n}\n\ndiv.mpo {\n    margin-right: 20px !important;\n    font-size: 20pt;\n}\n\ndiv.mpo p {\n    width: 232px;\n    margin: auto;\n    text-align:  left;\n    height: 28px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
